import { render } from "./NBanner.vue?vue&type=template&id=672388e4"
import script from "./NBanner.vue?vue&type=script&lang=js"
export * from "./NBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__